import WithGASetup from '../../components/WithGASetup';
import SignupPage from './SignupPage.js';

export default WithGASetup(SignupPage);
